import { Component, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WebsiteService } from '../../../core/services/website.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { EnquiryRequest, EnquiryType } from '../../../core/models/enquiry.model';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-floating-enquiry',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './floating-enquiry.component.html',
  styleUrl: './floating-enquiry.component.scss',
})
export class FloatingEnquiryComponent implements OnDestroy {
  private websiteService = inject(WebsiteService);
  private spinner = inject(NgxSpinnerService);
  private toastr = inject(ToastrService);
  private destroy$ = new Subject<void>();

  showEnquiryModal = false;

  enquiryForm = {
    name: '',
    phone: '',
    email: '',
    city: '',
    state: '',
    description: ''
  };

  openEnquiryModal() {
    this.showEnquiryModal = true;
    document.body.style.overflow = 'hidden';
  }

  closeEnquiryModal() {
    this.showEnquiryModal = false;
    document.body.style.overflow = '';
  }

  submitEnquiry() {
    this.spinner.show();

    const request: EnquiryRequest = {
        name: this.enquiryForm.name,
        email: this.enquiryForm.email,
        phone: this.enquiryForm.phone,
        cityAndState: `${this.enquiryForm.city}${this.enquiryForm.city && this.enquiryForm.state ? ', ' : ''}${this.enquiryForm.state}`,
        message: this.enquiryForm.description,
        type: EnquiryType.CONTACT
    };

    this.websiteService.sendEnquiry(request).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.spinner.hide();
        this.toastr.success('Thank you for reaching out! We will contact you soon.', 'Success');
        this.resetForm();
        this.closeEnquiryModal();
      },
      error: (err) => {
        this.spinner.hide();
        console.error('Failed to submit enquiry', err);
        this.toastr.error('There was an error submitting your request. Please try again later.', 'Error');
      }
    });
  }

  resetForm() {
    this.enquiryForm = {
      name: '',
      phone: '',
      email: '',
      city: '',
      state: '',
      description: ''
    };
  }

  onlyNumbers(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar) && event.charCode !== 0) {
      event.preventDefault();
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    document.body.style.overflow = '';
  }
}
